import React, { useState, useEffect, useRef } from 'react'

const DropDownLite = ({ optionList, handleChangeOption, closeDropdown, isMatchAllActive = false }) => {
  let [isCursorInside, setIsCursorInside] = useState(false)

  let dropdownValueRef: any = useRef({})
  dropdownValueRef.current.isCursorInside = isCursorInside

  const handleClickOutside = (e) => {
    if (!dropdownValueRef.current.isCursorInside) {
      console.log('click outside')

      closeDropdown()
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [isMatchAllActive])

  let suggestionsLength = optionList.length
  return (
    <div
      style={{ top: '41px' }}
      className={`AdvancedQueryView__suggestion-dropdown`}
      onMouseEnter={() => {
        setIsCursorInside(true)
      }}
      onMouseLeave={() => {
        setIsCursorInside(false)
      }}>
      <ul
        className={`AdvancedQueryView__suggestion-items ${suggestionsLength > 9 ? 'AdvancedQueryView__suggestion-items--limit' : ''
          }`}
        id="AdvancedQueryView__suggestion-items-dropdownlite"
      >
        {optionList.map((option, optIndex) => {
          return (
            <li
              tabIndex={0}
              key={optIndex}
              className={`AdvancedQueryView__suggestion-item AdvancedQueryView__suggestion-item--selectable`}
              onClick={(e) => handleChangeOption(e, option)}
              data-test-id="cs-advance-search-condition-list-element">
              <div>{option.label}</div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default DropDownLite
